/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnsweredState } from '../models/AnsweredState';
import type { AnswerQuestionnaireRequest } from '../models/AnswerQuestionnaireRequest';
import type { AnswerQuestionnaireResponse } from '../models/AnswerQuestionnaireResponse';
import type { CopyQuestionnaireRequest } from '../models/CopyQuestionnaireRequest';
import type { CreateQuestionnaireRequest } from '../models/CreateQuestionnaireRequest';
import type { CreateQuestionnaireResponse } from '../models/CreateQuestionnaireResponse';
import type { GetQuestionnaireAnswerResponse } from '../models/GetQuestionnaireAnswerResponse';
import type { GetQuestionnaireResponse } from '../models/GetQuestionnaireResponse';
import type { GetQuestionnaireStatsResponse } from '../models/GetQuestionnaireStatsResponse';
import type { QuestionnaireListResponse } from '../models/QuestionnaireListResponse';
import type { QuestionnaireState } from '../models/QuestionnaireState';
import type { ShareQuestionnaireRequest } from '../models/ShareQuestionnaireRequest';
import type { UnShareQuestionnaireRequest } from '../models/UnShareQuestionnaireRequest';
import type { UpdateQuestionnaireRequest } from '../models/UpdateQuestionnaireRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QuestionnairesService {
    /**
     * Updates a questionnaire.
     * Updates a questionnaire with provided details.
     * @param id
     * @param requestBody
     * @returns any The questionnaire has been updated successfully.
     * @throws ApiError
     */
    public static updateQuestionnaireEndpoint(
        id: string,
        requestBody: UpdateQuestionnaireRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get person for current user
     * Get person for current user, if this user is created based on person
     * @param id
     * @returns GetQuestionnaireResponse Successfully found questionnaire.
     * @throws ApiError
     */
    public static getQuestionnaireEndpoint(
        id: string,
    ): CancelablePromise<GetQuestionnaireResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed.`,
                404: `A questionnaire not found.`,
            },
        });
    }
    /**
     * Deletes a questionnaire
     * Deletes a questionnaire
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteQuestionnaireEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/questionnaires/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed.`,
                404: `A questionnaire not found.`,
            },
        });
    }
    /**
     * UnShares a questionnaire from a person.
     * UnShares a questionnaire from a person.
     * @param id
     * @param requestBody
     * @returns any The questionnaire has been unshared successfully.
     * @throws ApiError
     */
    public static unShareQuestionnaireEndpoint(
        id: string,
        requestBody: UnShareQuestionnaireRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}/unshare',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get person for current user
     * Get person for current user, if this user is created based on person
     * @param id
     * @param filterId
     * @param fromDate
     * @param toDate
     * @returns GetQuestionnaireStatsResponse Successfully found questionnaire stats.
     * @throws ApiError
     */
    public static getQuestionnaireStatsEndpoint(
        id: string,
        filterId?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
    ): CancelablePromise<GetQuestionnaireStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires/{id}/stats',
            path: {
                'id': id,
            },
            query: {
                'filterId': filterId,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed.`,
                404: `Questionnaire stats not found.`,
            },
        });
    }
    /**
     * Exports a questionnaire stats.
     * Exports a questionnaire stats.
     * @param id
     * @param filterId
     * @param fromDate
     * @param toDate
     * @returns void
     * @throws ApiError
     */
    public static exportQuestionnaireStatsEndpoint(
        id: string,
        filterId?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires/{id}/stats/export',
            path: {
                'id': id,
            },
            query: {
                'filterId': filterId,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Shares a questionnaire with a person.
     * Shares a questionnaire with a person.
     * @param id
     * @param requestBody
     * @returns any The questionnaire has been shared successfully.
     * @throws ApiError
     */
    public static shareQuestionnaireEndpoint(
        id: string,
        requestBody: ShareQuestionnaireRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}/share',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Publishes a questionnaire.
     * Publishes a questionnaire with provided details.
     * @param id
     * @returns any The questionnaire has been published successfully.
     * @throws ApiError
     */
    public static publishQuestionnaireEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}/publish',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of questionnaires.
     * Gets a list of questionnaires.
     * @param personId
     * @param sharedOnly
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param answered
     * @param searchTerm Search by the products.
     * @returns QuestionnaireListResponse List of questionnaires has been retrieved successfully.
     * @throws ApiError
     */
    public static getQuestionnaireSharedListEndpoint(
        personId: string,
        sharedOnly?: boolean | null,
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<QuestionnaireState> | null,
        answered?: Array<AnsweredState> | null,
        searchTerm?: string | null,
    ): CancelablePromise<QuestionnaireListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires/shared',
            query: {
                'personId': personId,
                'sharedOnly': sharedOnly,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'answered': answered,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of questionnaires.
     * Gets a list of questionnaires.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param answered
     * @param searchTerm Search by the products.
     * @returns QuestionnaireListResponse List of questionnaires has been retrieved successfully.
     * @throws ApiError
     */
    public static getQuestionnaireListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<QuestionnaireState> | null,
        answered?: Array<AnsweredState> | null,
        searchTerm?: string | null,
    ): CancelablePromise<QuestionnaireListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'answered': answered,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Add a questionnaire.
     * Add a questionnaire to the system using the CreateQuestionnaireEndpoint.
     * @param requestBody
     * @returns CreateQuestionnaireResponse Successfully created the questionnaire.
     * @throws ApiError
     */
    public static createQuestionnaireEndpoint(
        requestBody: CreateQuestionnaireRequest,
    ): CancelablePromise<CreateQuestionnaireResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/questionnaires',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
            },
        });
    }
    /**
     * Get person for current user
     * Get person for current user, if this user is created based on person
     * @param id
     * @param personId
     * @returns GetQuestionnaireAnswerResponse Successfully found questionnaire answer.
     * @throws ApiError
     */
    public static getQuestionnaireAnswerEndpoint(
        id: string,
        personId: string,
    ): CancelablePromise<GetQuestionnaireAnswerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/questionnaires/{id}/answer/{personId}',
            path: {
                'id': id,
                'personId': personId,
            },
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed.`,
                404: `A questionnaire answer not found.`,
            },
        });
    }
    /**
     * Deactivates a questionnaire.
     * Deactivates a questionnaire with provided details.
     * @param id
     * @returns any The questionnaire has been deactivated successfully.
     * @throws ApiError
     */
    public static deactivateQuestionnaireEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}/deactivate',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Adds a copy of questionnaire in system.
     * Adds a copy of questionnaire to the system using the CreateQuestionnaireEndpoint.
     * @param id
     * @param requestBody
     * @returns CreateQuestionnaireResponse Successfully created the questionnaire.
     * @throws ApiError
     */
    public static copyQuestionnaireEndpoint(
        id: string,
        requestBody: CopyQuestionnaireRequest,
    ): CancelablePromise<CreateQuestionnaireResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/questionnaires/{id}/copy',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
            },
        });
    }
    /**
     * Answer a questionnaire.
     * Answer an questionnaire shared with a user.
     * @param id
     * @param requestBody
     * @returns AnswerQuestionnaireResponse Successfully created the questionnaire.
     * @throws ApiError
     */
    public static answerQuestionnaireEndpoint(
        id: string,
        requestBody: AnswerQuestionnaireRequest,
    ): CancelablePromise<AnswerQuestionnaireResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/questionnaires/{id}/answer',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Activates a questionnaire.
     * Activates a questionnaire with provided details.
     * @param id
     * @returns any The questionnaire has been activated successfully.
     * @throws ApiError
     */
    public static activateQuestionnaireEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/questionnaires/{id}/activate',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
}
